// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsEvents_container__Vco4W","nav":"NewsEvents_nav__5D3Jb","content":"NewsEvents_content__3tfRD"};